import { gsap } from "gsap";

export default class filtrado {
    constructor() {
        const resultado_ = document.querySelector("#resultado");

        this.lastInteract = "";

        if (resultado_) {
            this.filtros_ = document.querySelector("#content-filter-popup");
            this.order_ = this.filtros_.querySelector(".order");
            this.category_ = this.filtros_.querySelector(".category");
            this.price_range_ = this.filtros_.querySelector(".price-range");
            this.marca_ = this.filtros_.querySelector(".marca");
            this.modelo_ = this.filtros_.querySelector(".modelo");
            this.year_ = this.filtros_.querySelector(".year");
            this.sistema_operativo_ = this.filtros_.querySelector(".sistema-operativo");
            this.color_ = this.filtros_.querySelector(".color");
            this.almacenamiento_ = this.filtros_.querySelector(".almacenamiento");
            this.ram_ = this.filtros_.querySelector(".ram");
            this.procesador_ = this.filtros_.querySelector(".procesador");
            this.capacidad_ = this.filtros_.querySelector(".capacidad");
            this.pantalla_ = this.filtros_.querySelector(".pantalla");
            this.estado_ = this.filtros_.querySelector(".estado");

            this.filtrosArr = [
                { filtro: "order", obj: this.order_ },
                { filtro: "category", obj: this.category_ },
                { filtro: "price-range", obj: this.price_range_ },
                { filtro: "marca", obj: this.marca_ },
                { filtro: "modelo", obj: this.modelo_ },
                { filtro: "year", obj: this.year_ },
                { filtro: "sistema-operativo", obj: this.sistema_operativo_ },
                { filtro: "color", obj: this.color_ },
                { filtro: "almacenamiento", obj: this.almacenamiento_ },
                { filtro: "ram", obj: this.ram_ },
                { filtro: "procesador", obj: this.procesador_ },
                { filtro: "capacidad", obj: this.capacidad_ },
                { filtro: "pantalla", obj: this.pantalla_ },
                { filtro: "estado", obj: this.estado_ },
            ];

            this.resultados_ = document.querySelector(".content-resultado .container .grid");

            //this.borrar_ = this.filtros_.querySelector(".borrarBot");
            this.filtrar_ = this.filtros_.querySelector(".filtrarBot");

           /* this.borrar_.addEventListener("click", () => {
                this.deleteFilters();
            });*/

            this.filtrar_.addEventListener("click", () => {
                this.jsonData();
            });

            //ORDER EVENT
            const orderAllinputs = this.order_.querySelectorAll("input");
            orderAllinputs.forEach((inp) => {
                inp.addEventListener("click", () => {
                    console.log("cambiado el orden");
                    this.lastInteract = "order";
                    //setTimeout(() => { this.jsonData (); }, 1);
                });
            });

            //CATEGORY EVENT
            this.categorySelect_ = this.filtros_.querySelector(".category select");
            this.categorySelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("Categoría seleccionada:", valor);
                this.lastInteract = "category";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //PRICE-RANGE EVENT
            const sliderEl = this.price_range_.querySelector("#slider-round");
            const attachHandler = () => {
                if (!sliderEl.noUiSlider) {
                    requestAnimationFrame(attachHandler); // vuelve a intentar en el siguiente frame
                    return;
                }
                sliderEl.noUiSlider.on("set", (values) => {
                    const [min, max] = values.map((v) => Math.round(v));
                    this.price_range_.querySelector("#min-value").textContent = `€${min}`;
                    this.price_range_.querySelector("#max-value").textContent = `€${max}`;
                    console.log("Price-range cambiado:", min, max);
                    this.lastInteract = "price-range";
                });
            };

            attachHandler();

            /**/

            //MARCA EVENT
            this.marcaSelect_ = this.filtros_.querySelector(".marca select");
            this.marcaSelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("Marca seleccionada:", valor);
                this.lastInteract = "marca";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //MODELO EVENT
            this.modeloSelect_ = this.filtros_.querySelector(".modelo select");
            this.modeloSelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("modelo seleccionada:", valor);
                this.lastInteract = "modelo";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //YEAR/FECHA EVENT
            this.year_.addEventListener("change", (e) => {
                // ¿cambió un checkbox de years[]?
                if (e.target.matches('input[type="checkbox"][name="years[]"]')) {
                    const valor = e.target.value;
                    console.log("años cambiado:", valor);

                    this.lastInteract = valor == "todos" ? "allyear" : "year";
                    //setTimeout(() => { this.jsonData (); }, 1);
                }
            });

            //COLOR EVENT
            this.color_.addEventListener("change", (e) => {
                if (!e.target.matches('input[type="checkbox"][name="ordenar"]')) return;
                const valor = e.target.value;
                console.log("Cambiado el color:", valor);

                this.lastInteract = valor == "todos" ? "allcolor" : "color";
                //this.lastInteract = "color";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //ALMACENAMIENTO EVENT
            this.almacenamientoSelect_ = this.filtros_.querySelector(".almacenamiento select");
            this.almacenamientoSelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("almacenamiento seleccionada:", valor);
                this.lastInteract = "almacenamiento";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //RAM EVENT
            this.ramSelect_ = this.filtros_.querySelector(".ram select");
            this.ramSelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("ram seleccionada:", valor);
                this.lastInteract = "ram";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //PROCESADOR EVENT
            this.procesadorSelect_ = this.filtros_.querySelector(".procesador select");
            this.procesadorSelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("procesador seleccionada:", valor);
                this.lastInteract = "procesador";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //CAPACIDAD EVENT
            this.capacidadSelect_ = this.filtros_.querySelector(".capacidad select");
            this.capacidadSelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("capacidad seleccionada:", valor);
                this.lastInteract = "capacidad";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //PANTALLA EVENT
            this.pantallaSelect_ = this.filtros_.querySelector(".pantalla select");
            this.pantallaSelect_.addEventListener("change", (e) => {
                const valor = e.target.value;
                console.log("pantalla seleccionada:", valor);
                this.lastInteract = "pantalla";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            //ESTADO EVENT
            this.estado_.addEventListener("change", (e) => {
                if (!e.target.matches('input[type="checkbox"][name="ordenar"]')) return;
                const valor = e.target.value;
                console.log("Cambiado el estado:", valor);
                this.lastInteract = "estado";
                //setTimeout(() => { this.jsonData (); }, 1);
            });

            /* Filtros header */
            this.orderHeader_ = document.querySelector("#order_header");
            this.marcaHeader_ = document.querySelector("#marca_header");
            this.modeloHeader_ = document.querySelector("#modelo_header");
            this.precioHeader_ = document.querySelector("#precio_header");

            this.orderHeader_.addEventListener("change", (event) => {
                console.log("cambio ORDER del header");
                const valueOr = event.target.value;

                //ORDER performance
                const allinputs = this.order_.querySelectorAll("input");
                const checkboxes = this.order_.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((cb) => (cb.checked = false));
                allinputs.forEach((inp) => {
                    if (normalizar(inp.value) == normalizar(valueOr)) inp.checked = true;
                });

                this.lastInteract = "order";
                //this.jsonData ();
            });

            this.marcaHeader_.addEventListener("change", (event) => {
                const valueMar = event.target.value;

                const select = this.marca_.querySelector(".select");
                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(valueMar));
                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;

                this.lastInteract = "marca";
                //this.jsonData ();
            });

            this.modeloHeader_.addEventListener("change", (event) => {
                const valueMod = event.target.value;

                const select = this.modelo_.querySelector(".select");
                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(valueMod));
                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;

                this.lastInteract = "modelo";
                //this.jsonData ();
            });

            /*this.precioHeader_.addEventListener("change", (event)=> {
                //console.log ("cambio PRECIO del header");
                //const valuePre = event.target.value;
                //console.log (valuePre);
                //this.jsonData ();
            });*/

            this.initExclusiveAll = (groupRoot) => {
                if (!groupRoot) return;

                // permite .content-xxx por si existiera contenedor interior
                const root = groupRoot.querySelector('[class^="content-"]') || groupRoot;

                // Limpia inits previos
                if (root.__cleanupExclusiveAll) root.__cleanupExclusiveAll();

                const isAll = (v) => /^(todos|all)$/i.test(String(v));

                const getBoxes = () => Array.from(root.querySelectorAll('input[type="checkbox"][name="ordenar"]'));

                const getAllBox = (boxes) => boxes.find((cb) => isAll(cb.value));
                const getOthers = (boxes, all) => boxes.filter((cb) => cb !== all);

                const onChange = (e) => {
                    // En 'change', el target SIEMPRE es el <input>, aunque hayas clicado el <label>/<svg>
                    const input = e.target;
                    if (!(input instanceof HTMLInputElement) || input.type !== "checkbox") return;
                    if (!root.contains(input)) return;

                    const boxes = getBoxes();
                    const all = getAllBox(boxes);
                    if (!all) return;
                    const others = getOthers(boxes, all);

                    if (input === all) {
                        // Marcar "Todos" => desmarca resto
                        if (all.checked) others.forEach((cb) => (cb.checked = false));
                        return;
                    }
                    // Marcar cualquiera => desmarca "Todos"
                    if (input.checked && all.checked) all.checked = false;
                };

                // Captura: evita que otros scripts con stopPropagation te bloqueen
                root.addEventListener("change", onChange, true);

                root.__cleanupExclusiveAll = () => {
                    root.removeEventListener("change", onChange, true);
                    delete root.__cleanupExclusiveAll;
                };
            };

            this.initExclusiveAll(this.estado_);
            this.initExclusiveAll(this.sistema_operativo_);
            this.initExclusiveAll(this.color_);

            this.order_ = this.filtros_.querySelector(".order");

            // selecciona todos los checkboxesOrden dentro de .order
            const checkboxesOrder = this.order_.querySelectorAll('input[type="checkbox"]');

            checkboxesOrder.forEach((cb) => {
                cb.addEventListener("change", () => {
                    if (cb.checked) {
                        // desmarcar todos los demás
                        checkboxesOrder.forEach((other) => {
                            if (other !== cb) {
                                other.checked = false;
                            }
                        });
                    }
                });
            });
        }
    }

    yearFilterBehavior() {
        // todos los checkboxes dentro de .year
        const checkboxes = this.year_.querySelectorAll('input[type="checkbox"]');
        const checkTodos = this.year_.querySelector('input[value="todos"]');

        checkboxes.forEach((cb) => {
            cb.addEventListener("change", () => {
                if (cb === checkTodos && cb.checked) {
                    checkboxes.forEach((other) => {
                        if (other !== checkTodos) {
                            other.checked = false;
                        }
                    });
                } else if (cb !== checkTodos && cb.checked) {
                    checkTodos.checked = false;
                }
            });
        });
    }

    deleteFilters() {
        const checkboxes = this.order_.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((cb) => (cb.checked = false));

        const select = this.category_.querySelector("select");
        select.selectedIndex = 0;

        const slider = this.price_range_.querySelector("#slider-round").noUiSlider;
        slider.set([slider.options.range.min, slider.options.range.max]);

        const selectM = this.marca_.querySelector("select");
        selectM.selectedIndex = 0;

        const selectMod = this.modelo_.querySelector("select");
        selectMod.selectedIndex = 0;

        //const allCheckbox = this.year_.querySelector('input[value="all"]');
        const others = this.year_.querySelectorAll('input[type="checkbox"]:not([value="all"])');

        //allCheckbox.checked = true;
        others.forEach((cb) => (cb.checked = false));

        const checkboxes_COLOR = this.color_.querySelectorAll('input[type="checkbox"]');
        checkboxes_COLOR.forEach((cb) => (cb.checked = false));

        const checkboxes_OS = this.sistema_operativo_.querySelectorAll('input[type="checkbox"]');
        checkboxes_OS.forEach((cb) => (cb.checked = false));
        //if (checkboxes_OS.length > 0) checkboxes_OS[0].checked = true;

        const selAlma = this.almacenamiento_.querySelector("select");
        selAlma.selectedIndex = 0;

        const selram = this.ram_.querySelector("select");
        selram.selectedIndex = 0;

        const selProce = this.procesador_.querySelector("select");
        selProce.selectedIndex = 0;

        const sleProce = this.procesador_.querySelector("select");
        sleProce.selectedIndex = 0;

        const selCapa = this.capacidad_.querySelector("select");
        selCapa.selectedIndex = 0;

        const selpanta = this.pantalla_.querySelector("select");
        selpanta.selectedIndex = 0;

        const checkboxes_estado = this.estado_.querySelectorAll('input[type="checkbox"]');
        checkboxes_estado.forEach((cb) => (cb.checked = false));
        //if (checkboxes_estado.length > 0) checkboxes_estado[0].checked = true;

        /*
        this.estado_ = this.filtros_.querySelector(".estado");
        */
    }

    init() {
        const resultado_ = document.querySelector("#resultado");

        if (resultado_) {
            const dataDocument_ = window.getFilterResultado();
            setTimeout(() => {
                this.fillFiltrado(dataDocument_);

                this.renderFiltrado(dataDocument_);
                this.renderResultados(dataDocument_);
                //this.jsonData ();
            }, 100);
        }
    }

    jsonData() {
        const resultado_ = document.querySelector("#resultado");
        const params_ = this.getFilterOptions();
        params_.category_filter = window.category_filter;

        console.log (params_)
        const url = this.generarURL("https://merkia.rearmachinekitchen.com/products_filter/", params_);
        console.log(url);

        if (resultado_) {
            fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
                .then((response) => {
                    if (!response.ok) throw new Error("Error en la respuesta del servidor");
                    return response.json();
                })
                .then((data) => {
                    const dataDocument_ = data;
                    this.fillFiltrado(dataDocument_);

                    this.renderFiltrado(dataDocument_);
                    this.renderResultados(dataDocument_);
                })
                .catch((error) => {
                    console.error("Error al cargar el JSON:", error);
                });
        }
    }

    generarURL(baseURL, filtros) {
        const params = Object.entries(filtros)
            .filter(([_key, value]) => value !== "" && value !== "all" && value !== "todos")
            .map(([_key, value]) => `${encodeURIComponent(_key)}=${encodeURIComponent(value)}`)
            .join("&");
        return params ? `${baseURL}?${params}` : baseURL;
    }

    renderResultados(data) {
        const button_ = document.querySelector(".content-button");
        const contentResultado_ = document.querySelector(".content-resultado");
        const grid_ = contentResultado_?.querySelector(".grid");
        if (!grid_) return;
        // Vaciar el contenido de grid
        grid_.innerHTML = "";

        // Obtener productos
        //const resultadosObj = data.find(item => item.resultado);
        const resultadosObj = { resultado: data.productos };
        const productos = Array.isArray(resultadosObj?.resultado) ? resultadosObj.resultado : [];

        // Estado de paginación
        const PAGE_SIZE = 8;
        let cursor = 0;

        // Utilidad para mostrar/ocultar botón
        const setButtonVisible = (visible) => {
            if (!button_) return;
            button_.style.display = visible ? "" : "none";
            button_.setAttribute("aria-hidden", String(!visible));
        };

        // Render de un bloque (batch) de productos
        const renderBatch = () => {
            const slice = productos.slice(cursor, cursor + PAGE_SIZE);
            if (!slice.length) {
                setButtonVisible(false);
                return;
            }

            const frag = document.createDocumentFragment();

            slice.forEach((producto) => {
                const item = document.createElement("div");
                item.className = "grid__item grid__item--3";
                item.innerHTML = `
                    <a href="${producto.url}" title="${producto.title ?? ""}">
                    <div class="card--interest">
                        <div class="card-image">
                        <img src="${producto.img}" alt="${producto.title ?? ""}">
                        </div>
                        <div class="card-text">
                        <div class="pretitle">${producto.pretitle ?? ""}</div>
                        <div class="title title--s">${producto.title ?? ""}</div>
                        <div class="wysiwyg wysiwyg--small">Descripción de producto</div>
                        <div class="characteristics">
                            <div class="wysiwyg wysiwyg--xsmall">Desde</div>
                            <div class="precio">${producto.precioahora}€<span>${producto.precioantes}€</span></div>
                            <div class="colors">${producto.colors ?? ""}</div>
                        </div>
                        </div>
                    </div>
                    </a>
                `;

                //<img src="${producto.img}" alt="${producto.title ?? ""}">
                // <img src="img/img-interest.png" alt="${producto.title ?? ""}">

                frag.appendChild(item);
            });

            grid_.appendChild(frag);
            cursor += slice.length;

            // Si ya no quedan más, ocultar botón
            setButtonVisible(cursor < productos.length);
        };

        // Reset inicial
        grid_.innerHTML = "";

        // (Re)asignar handler del botón sin duplicarlo
        if (button_) {
            if (button_.__loadMoreHandler) {
                button_.removeEventListener("click", button_.__loadMoreHandler);
            }
            button_.__loadMoreHandler = () => renderBatch();
            button_.addEventListener("click", button_.__loadMoreHandler);
        }

        // Primera carga
        renderBatch();

        // Si no hay productos, ocultar botón también
        if (!productos.length) setButtonVisible(false);
    }

    getFilterOptions() {
        //get ORDER
        this.order_ = this.filtros_.querySelector(".order");
        this.getOrdenSeleccionado = () => {
            if (!this.order_) return "";
            const checks = this.order_.querySelectorAll('input[name="ordenar"]:checked');
            return Array.from(checks)
                .map((el) => el.value.trim())
                .filter(Boolean)
                .join("|");
        };
        let order_send = this.getOrdenSeleccionado();

        //get CATEGORY
        this.category_ = this.filtros_.querySelector(".category");
        this.getCategoriaSeleccionada = () => {
            const select = this.category_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^selecciona/i.test(val)) return "";
            return val; // p.ej. "Móviles"
        };
        let category_send = this.getCategoriaSeleccionada();

        //get PRICE
        this.price_range_ = this.filtros_.querySelector(".price-range");
        // Extrae "min|max" en formato numérico (p. ej. "5|6000")
        this.getPriceRangeString = () => {
            const minEl = this.price_range_?.querySelector("#min-value");
            const maxEl = this.price_range_?.querySelector("#max-value");
            if (!minEl || !maxEl) return "";

            const parseNum = (s) => {
                // coge la primera secuencia numérica con , o .
                const m = String(s ?? "").match(/[\d.,]+/);
                if (!m) return NaN;
                // quita separadores de miles y normaliza decimal
                const n = m[0].replace(/\./g, "").replace(",", ".");
                return parseFloat(n);
            };

            let min = parseNum(minEl.textContent);
            let max = parseNum(maxEl.textContent);
            if (isNaN(min) || isNaN(max)) return "";

            // asegúrate de que min <= max
            if (min > max) [min, max] = [max, min];

            // redondea a entero si quieres evitar decimales
            min = Math.round(min);
            max = Math.round(max);

            return `${min}|${max}`;
        };
        let minmaxprize_send = this.getPriceRangeString();

        //get MARCA
        this.marca_ = this.filtros_.querySelector(".marca");
        this.getMarcaSeleccionada = () => {
            const select = this.marca_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^Buscar/i.test(val)) return "";
            return val;
        };
        let marca_send = this.getMarcaSeleccionada();

        //get MODELO
        this.modelo_ = this.filtros_.querySelector(".modelo");
        this.getModeloSeleccionada = () => {
            const select = this.modelo_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^Buscar/i.test(val)) return "";
            return val;
        };
        let modelo_send = this.getModeloSeleccionada();

        //get YEAR
        this.year_ = this.filtros_.querySelector(".year");
        this.initYearHandlers = () => {
            const all = this.year_?.querySelector('input[name="years[]"][value="todos"]');
            const years = this.year_?.querySelectorAll('input[name="years[]"]:not([value="todos"])');
            if (!all || !years?.length) return;

            all.addEventListener("change", () => {
                if (all.checked) years.forEach((y) => (y.checked = false));
            });

            years.forEach((y) => {
                y.addEventListener("change", () => {
                    if (y.checked) all.checked = false;
                });
            });
        };

        this.getYearsString = () => {
            if (!this.year_) return "";
            const checked = this.year_.querySelectorAll('input[name="years[]"]:checked');
            if (!checked.length) return "";

            // Si está marcado "Todos", devolvemos "all"
            const hasAll = Array.from(checked).some((el) => el.value === "all");
            if (hasAll) return "all";

            return Array.from(checked)
                .map((el) => el.value.trim())
                .filter(Boolean)
                .join("|");
        };
        let years_send = this.getYearsString();

        //get SISTEMA OPERATIVO
        this.sistema_operativo_ = this.filtros_.querySelector(".sistema-operativo");
        this.getOSSeleccionado = () => {
            if (!this.sistema_operativo_) return "";
            const checks = this.sistema_operativo_.querySelectorAll('input[type="checkbox"]:checked');

            const values = Array.from(checks)
                .map((el) => (el.value || "").trim())
                .filter(Boolean);

            // Si incluye "todos" (o "all"), devolver solo "todos"
            if (values.some((v) => v.toLowerCase() === "todos" || v.toLowerCase() === "all")) {
                return "all";
            }
            return values.join("|");
        };
        let OS_send = this.getOSSeleccionado();

        //get COLOR
        this.color_ = this.filtros_.querySelector(".color");
        this.getColorSeleccionado = () => {
            if (!this.color_) return "";
            const checks = this.color_.querySelectorAll('input[type="checkbox"]:checked');

            const values = Array.from(checks)
                .map((el) => (el.value || "").trim())
                .filter(Boolean);

            // Si incluye "todos" (o "all"), devolver solo "todos"
            if (values.some((v) => v.toLowerCase() === "todos" || v.toLowerCase() === "all")) {
                return "all";
            }
            return values.join("|");
        };
        let color_send = this.getColorSeleccionado();

        //get ALMACENAMIENTO
        this.almacenamiento_ = this.filtros_.querySelector(".almacenamiento");
        this.getAlmacenamientoSeleccionada = () => {
            const select = this.almacenamiento_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^Buscar/i.test(val)) return "";
            return val;
        };
        let almacenamiento_send = this.getAlmacenamientoSeleccionada();

        //get RAM
        this.ram_ = this.filtros_.querySelector(".ram");
        this.getRAMSeleccionada = () => {
            const select = this.ram_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^Buscar/i.test(val)) return "";
            return val;
        };
        let ram_send = this.getRAMSeleccionada();

        //get PROCESADOR
        this.procesador_ = this.filtros_.querySelector(".procesador");
        this.getProcesadorSeleccionada = () => {
            const select = this.procesador_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^Buscar/i.test(val)) return "";
            return val;
        };
        let procesador_send = this.getProcesadorSeleccionada();

        //get CAPACIDAD
        this.capacidad_ = this.filtros_.querySelector(".capacidad");
        this.getCapacidadSeleccionada = () => {
            const select = this.capacidad_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^Buscar/i.test(val)) return "";
            return val;
        };
        let capacidad_send = this.getCapacidadSeleccionada();

        //get PANTALLA
        this.pantalla_ = this.filtros_.querySelector(".pantalla");
        this.getPantallaSeleccionada = () => {
            const select = this.pantalla_?.querySelector("select.select");
            if (!select) return "";
            const val = (select.value ?? "").trim(); // si no hay value en <option>, usa el texto
            if (!val || /^Buscar/i.test(val)) return "";
            return val;
        };
        let pantalla_send = this.getPantallaSeleccionada();

        //get ESTADO
        this.estado_ = this.filtros_.querySelector(".estado");
        this.getEstadoSeleccionado = () => {
            if (!this.estado_) return "";
            const checks = this.estado_.querySelectorAll('input[type="checkbox"]:checked');

            const values = Array.from(checks)
                .map((el) => (el.value || "").trim())
                .filter(Boolean);

            // Si incluye "todos" (o "all"), devolver solo "todos"
            if (values.some((v) => v.toLowerCase() === "todos" || v.toLowerCase() === "all")) {
                return "all";
            }
            return values.join("|");
        };
        let estado_send = this.getEstadoSeleccionado();

        //const base = "/";
        const values = {
            order: order_send,
            category: category_send,
            price_range: minmaxprize_send,
            marca: marca_send,
            modelo: modelo_send,
            year: years_send,
            "sistema-operativo": OS_send,
            color: color_send,
            almacenamiento: almacenamiento_send,
            ram: ram_send,
            procesador: procesador_send,
            capacidad: capacidad_send,
            pantalla: pantalla_send,
            estado: estado_send,
        };

        return values;
    }

    fillFiltrado(datos) {
        if (!this.resultados_) return;

        console.log(datos.filtros);

        let data = datos.filtros;

        data.forEach((ele) => {
            const res_ = this.filtrosArr.find((item) => item.filtro === ele.filtro);

            if (ele.activo == "no") gsap.set(res_.obj, { display: "none" });

            //ORDER performance
            /*
            if (ele.filtro == "order" && ele.activo != "no") {

                const allinputs = res_.obj.querySelectorAll ("input");
                allinputs.forEach(inp => {
                    if (normalizar(inp.value) == normalizar(ele.values)) inp.checked = true;
                });
            }
            */

            if (ele.filtro == "category" && this.lastInteract != "category") {
                // apunto directamente al <select>
                this.category_select = this.filtros_.querySelector(".category select");
                let valores_ = ele.values; // ej: ["Móviles", "Portátiles", "Accesorios"]

                // Limpio SOLO las opciones, no el <select>
                this.category_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona la categoría";
                optionDefault.value = "";
                this.category_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.category_select.appendChild(option);
                });
            }

            if (ele.filtro == "marca" && this.lastInteract != "marca") {
                // apunto directamente al <select>
                this.marca_select = this.filtros_.querySelector(".marca select");
                let valores_ = ele.values; // ej: ["Móviles", "Portátiles", "Accesorios"]

                // Limpio SOLO las opciones, no el <select>
                this.marca_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona la marca";
                optionDefault.value = "";
                this.marca_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.marca_select.appendChild(option);
                });
            }

            if (ele.filtro == "marca" && this.lastInteract != "marca") {
                // apunto directamente al <select>
                this.marca_select_header = this.marcaHeader_;
                let valores_ = ele.values; // ej: ["Móviles", "Portátiles", "Accesorios"]

                // Limpio SOLO las opciones, no el <select>
                this.marca_select_header.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona la marca";
                optionDefault.value = "";
                this.marca_select_header.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.marca_select_header.appendChild(option);
                });
            }

            if (ele.filtro == "modelo" && this.lastInteract != "modelo") {
                // apunto directamente al <select>
                this.modelo_select = this.filtros_.querySelector(".modelo select");
                let valores_ = ele.values; // ej: ["Móviles", "Portátiles", "Accesorios"]

                // Limpio SOLO las opciones, no el <select>
                this.modelo_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona un modelo";
                optionDefault.value = "";
                this.modelo_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.modelo_select.appendChild(option);
                });
            }

            if (ele.filtro == "modelo" && this.lastInteract != "modelo") {
                // apunto directamente al <select>
                this.modelo_select_header = this.modeloHeader_;
                let valores_ = ele.values; // ej: ["Móviles", "Portátiles", "Accesorios"]

                // Limpio SOLO las opciones, no el <select>
                this.modelo_select_header.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona un modelo";
                optionDefault.value = "";
                this.modelo_select_header.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.modelo_select_header.appendChild(option);
                });
            }

            if (ele.filtro == "year" && this.lastInteract != "year") {
                this.yearOPTS_ = this.filtros_.querySelector(".year .content-year");
                let valores_ = ele.values;
                // Ej: ['2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012']

                // console.log (valores_);

                // Limpio todo el contenedor
                this.yearOPTS_.innerHTML = "";

                // Opción "Todos" fija
                let labelTodos = document.createElement("label");
                labelTodos.classList.add("year-option");
                labelTodos.innerHTML = `
                    <input type="checkbox" name="years[]" value="todos">
                    <span>Todos</span>
                `;
                this.yearOPTS_.appendChild(labelTodos);

                // Añado dinámicamente los años
                valores_.forEach((year) => {
                    let label = document.createElement("label");
                    label.classList.add("year-option");
                    label.innerHTML = `
                        <input type="checkbox" name="years[]" value="${year}">
                        <span>${year}</span>
                    `;
                    this.yearOPTS_.appendChild(label);
                });
            }

            this.yearFilterBehavior();

            if (ele.filtro === "color" && this.lastInteract != "color") {
                this.colorOpts_ = this.filtros_.querySelector(".color .content-color");
                const valores_ = ele.values; // Ej: ['Rojo', 'Azul', 'Verde']
                const nameAttr = "ordenar"; // cámbialo si necesitas otro name

                // Vaciar contenedor
                this.colorOpts_.innerHTML = "";

                // Helper para crear cada opción
                const makeLabel = (value, text) => {
                    const label = document.createElement("label");
                    label.className = "checkbox-wrapper";
                    label.innerHTML = `
                    <input type="checkbox" name="${nameAttr}" value="${value}">
                    <span class="custom-check">
                        <svg viewBox="0 0 24 24">
                        <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </span>
                    ${text}
                    `;
                    return label;
                };

                // Opción fija "Todos"
                this.colorOpts_.appendChild(makeLabel("todos", "Todos"));

                // Resto de colores
                valores_.forEach((v) => {
                    this.colorOpts_.appendChild(makeLabel(v, v));
                });
            }

            this.initExclusiveAll(this.color_);

            if (ele.filtro == "almacenamiento" && this.lastInteract != "almacenamiento") {
                // apunto directamente al <select>
                this.almacenamiento_select = this.filtros_.querySelector(".almacenamiento select");
                let valores_ = ele.values;

                // Limpio SOLO las opciones, no el <select>
                this.almacenamiento_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona almacenamiento";
                optionDefault.value = "";
                this.almacenamiento_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.almacenamiento_select.appendChild(option);
                });
            }

            if (ele.filtro == "ram" && this.lastInteract != "ram") {
                // apunto directamente al <select>
                this.ram_select = this.filtros_.querySelector(".ram select");
                let valores_ = ele.values;

                // Limpio SOLO las opciones, no el <select>
                this.ram_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona ram";
                optionDefault.value = "";
                this.ram_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.ram_select.appendChild(option);
                });
            }

            if (ele.filtro == "procesador" && this.lastInteract != "procesador") {
                // apunto directamente al <select>
                this.procesador_select = this.filtros_.querySelector(".procesador select");
                let valores_ = ele.values;

                // Limpio SOLO las opciones, no el <select>
                this.procesador_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona procesador";
                optionDefault.value = "";
                this.procesador_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.procesador_select.appendChild(option);
                });
            }

            if (ele.filtro == "capacidad" && this.lastInteract != "capacidad") {
                // apunto directamente al <select>
                this.capacidad_select = this.filtros_.querySelector(".capacidad select");
                let valores_ = ele.values;

                // Limpio SOLO las opciones, no el <select>
                this.capacidad_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona capacidad";
                optionDefault.value = "";
                this.capacidad_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.capacidad_select.appendChild(option);
                });
            }

            if (ele.filtro == "pantalla" && this.lastInteract != "pantalla") {
                // apunto directamente al <select>
                this.pantalla_select = this.filtros_.querySelector(".pantalla select");
                let valores_ = ele.values;

                // Limpio SOLO las opciones, no el <select>
                this.pantalla_select.innerHTML = "";

                // Opción inicial fija
                let optionDefault = document.createElement("option");
                optionDefault.textContent = "Selecciona pantalla";
                optionDefault.value = "";
                this.pantalla_select.appendChild(optionDefault);

                // Agrego las opciones dinámicas
                valores_.forEach((valor) => {
                    let option = document.createElement("option");
                    option.value = valor;
                    option.textContent = valor;
                    this.pantalla_select.appendChild(option);
                });
            }
        });
    }

    renderFiltrado(datos) {
        if (!this.resultados_) return;

        let data = datos.filtros;

        data.forEach((ele) => {
            const res_ = this.filtrosArr.find((item) => item.filtro === ele.filtro);

            if (ele.activo == "no") gsap.set(res_.obj, { display: "none" });
            else gsap.set(res_.obj, { display: "block" });

            //ORDER performance
            if (ele.filtro == "order" && ele.activo != "no") {
                const checkboxes = this.order_.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((cb) => (cb.checked = false));
                const allinputs = res_.obj.querySelectorAll("input");
                let v_ = ele.selected.split("|");
                v_.forEach((valor) => {
                    allinputs.forEach((inp) => {
                        if (normalizar(inp.value) == normalizar(valor)) inp.checked = true;
                    });
                });
            }

            //ORDEN HEADER
            if (ele.filtro == "order") {
                console.log ("ORDER HEADER")
                let v_ = ele.selected.split("|");
                const select = this.orderHeader_;
                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                //console.log (v_[0]);

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //CATEGORIA performance
            if (ele.filtro == "category" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //PRIZE RANGE performance
            if (ele.filtro == "price-range" && ele.activo != "no") {
                const slider_ = res_.obj.querySelector("#slider-round");
                const handles = slider_.querySelectorAll(".noUi-handle");

                //const valuesPrecie = ele.value;
                let v_ = ele.selected.split("|");

                //const valorInferior = ele.minvalue;
                //const valorSuperior = ele.maxvalue;
                const valorInferior = v_[0];
                const valorSuperior = v_[1];

                if (handles[0]) handles[0].setAttribute("nowvalue", valorInferior); // .noUi-handle-lower
                if (handles[1]) handles[1].setAttribute("nowvalue", valorSuperior); // .noUi-handle-upper

                slider_.noUiSlider.set([valorInferior, valorSuperior]);
            }

            //PRECIO performance
            /*if (ele.filtro == "precio") {
                const select =  this.precioHeader_;
                const opcion = Array.from(select.options).find(opt =>  normalizar(opt.value) === normalizar(ele.value) );

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }*/

            //MARCA performance
            if (ele.filtro == "marca" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //MARCA HEADER
            if (ele.filtro == "marca") {
                const select = this.marcaHeader_;
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //MODELO performance
            if (ele.filtro == "modelo" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //MODELO HEADER
            if (ele.filtro == "modelo") {
                const select = this.modeloHeader_;
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //YEAR performance
            if (ele.filtro == "year" && ele.activo != "no") {
                const allinputs = res_.obj.querySelectorAll("input");
                let v_ = ele.selected.split("|");
                if (this.lastInteract == "allyear") v_ = ["todos"];
                //let v_ = ele.value;
                v_.forEach((valor) => {
                    allinputs.forEach((inp) => {
                        if (normalizar(inp.value) == normalizar(valor)) inp.checked = true;
                    });
                });
            }

            //COLOR performance
            if (ele.filtro == "color" && ele.activo != "no") {
                const allinputs = res_.obj.querySelectorAll("input");
                let v_ = ele.selected.split("|");
                if (this.lastInteract == "allcolor") v_ = ["todos"];

                v_.forEach((valor) => {
                    allinputs.forEach((inp) => {
                        if (normalizar(inp.value) == normalizar(valor)) inp.checked = true;
                    });
                });
            }

            //SITEMA-OPERATIVO performance
            if (ele.filtro == "sistema-operativo" && ele.activo != "no") {
                const allinputs = res_.obj.querySelectorAll("input");
                let v_ = ele.selected.split("|");
                //let v_ = ele.value;
                v_.forEach((valor) => {
                    allinputs.forEach((inp) => {
                        if (normalizar(inp.value) == normalizar(valor)) inp.checked = true;
                    });
                });
            }

            //ALMACENAMIENTO performance
            if (ele.filtro == "almacenamiento" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //RAM performance
            if (ele.filtro == "ram" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //PROCESADOR performance
            if (ele.filtro == "procesador" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //CAPACIDAD performance
            if (ele.filtro == "capacidad" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //PANTALLA performance
            if (ele.filtro == "pantalla" && ele.activo != "no") {
                const select = res_.obj.querySelector(".select");
                let v_ = ele.selected.split("|");

                const opcion = Array.from(select.options).find((opt) => normalizar(opt.value) === normalizar(v_[0]));

                if (opcion) opcion.selected = true;
                else select.selectedIndex = 0;
            }

            //ESTADO performance
            if (ele.filtro == "estado" && ele.activo != "no") {
                const checkboxes = this.estado_.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((cb) => (cb.checked = false));

                const allinputs = res_.obj.querySelectorAll("input");
                let v_ = ele.selected.split("|");
                v_.forEach((valor) => {
                    allinputs.forEach((inp) => {
                        if (normalizar(inp.value) == normalizar(valor)) inp.checked = true;
                    });
                });
            }
        });
    }
}

function normalizar(texto) {
    return texto
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
}
